import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { List, Typography } from "@mui/material";
import { Box } from "@mui/system";
import TextField from "@mui/material/TextField";
import { unicodeToString } from "../../../Js/Common";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import OptionMedia from "../../../Components/Card/AssetUI/OptionMedia";
import StatusIndicator from "../../../Components/Card/AssetUI/StatusIndicator";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const THESAURUS = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  const [userAnswer, setUserAnswer] = useState([]);
  const [logObj, setLogObj] = useState(initLogObj);
  const [currentIndexPlay, setCurrentIndexPlay] = useState([]);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt, optionWiseAns } =
    useSelector((state) => state.currentAsset);

  useEffect(() => {
    if (props.content) {
      let userAns = [];
      let actualAnswers = props.content.epage.options.content.map((val) => {
        userAns.push(new Array(val.NumberOfAnswers).fill(""));
        return val.answer.map((ans) => {
          return unicodeToString(ans);
        });
      });
      setUserAnswer(userAns);
      dispatch(currentAssetSliceActions.setCurrentAttemptData(userAns));
      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: actualAnswers,
      });
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
    dispatch(currentAssetSliceActions.setShowAnswer(false));
  }, [logObj]);

  useEffect(() => {
    let userAns = props.content.epage.options.content.map((val) => {
      return new Array(val.NumberOfAnswers).fill("");
    });
    setUserAnswer(userAns);
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    dispatch(currentAssetSliceActions.setCurrentAttemptData(userAns));
  }, [currentAttempt]);

  useEffect(() => {
    if (showAnswer && assetLogObj && assetLogObj.actualAnswer) {
      setUserAnswer(assetLogObj.actualAnswer);
    }
  }, [showAnswer, assetLogObj]);

  useEffect(() => {
    return () => {
      setUserAnswer([]);
    };
  }, []);

  const setPlayMode = (status, index, end) => {
    if (status == true && !end && !currentIndexPlay[index]) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      arr[index] = status;
      setCurrentIndexPlay(arr);
    }
    if (currentIndexPlay[index] || end) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      setCurrentIndexPlay(arr);
    }
  };

  const updateUserAnswer = (text, optionIndex, innerIndex) => {
    if (!showAnswer && !attempted) {
      let newArray = [...userAnswer];
      let innerArray = newArray[optionIndex].map((item, i) => {
        if (innerIndex === i) {
          return text.trim();
        } else {
          return item.trim();
        }
      });
      newArray[optionIndex] = [...innerArray];
      setUserAnswer(newArray);
      dispatch(currentAssetSliceActions.setCurrentAttemptData(newArray));
    }
  };

  return (
    <Box   sx={{ mt: 1 }}>
      {props.content &&
        props.content.epage.options.content.map((item, index) => {
          return (
            <Grid
              container
              sx={{ px: 2, py: 2, borderBottom: 1, borderColor: "#EFEFEF" }}
            >
              <Grid item xs={12}>
                {item && item.media && (
                  <OptionMedia
                    media={item.media}
                    isPlaying={currentIndexPlay[index]}
                    setPlayMode={(status, end) => {
                      setPlayMode(status, index, end);
                    }}
                  ></OptionMedia>
                )}
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: "primary.main",
                    "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                  }}
                >
                  {unicodeToString(item.text)}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-start" }}
              >
                {item.NumberOfAnswers &&
                  !showAnswer &&
                  new Array(item.NumberOfAnswers)
                    .fill("")
                    .map((val, index1) => {
                      return (
                        <Box sx={{ width: "12vw", mx: 1 }}>
                          <TextField
                            variant="standard"
                            value={
                              userAnswer &&
                              userAnswer[index] &&
                              userAnswer[index][index1]
                                ? userAnswer[index][index1]
                                : ""
                            }
                            disabled={showAnswer && attempted}
                            onInput={(event) => {
                              updateUserAnswer(
                                event.target.value,
                                index,
                                index1
                              );
                            }}
                            InputProps={{
                              inputProps: {
                                style: {
                                  fontSize: "1.1vw",
                                  color: "#DB8829",
                                  fontWeight: "500",
                                },
                              },
                              endAdornment: (
                                <>
                                  {optionWiseAns &&
                                    optionWiseAns.length > 0 &&
                                    optionWiseAns[index] != undefined &&
                                    optionWiseAns[index][index1] !=
                                      undefined && (
                                      <StatusIndicator
                                        correct={optionWiseAns[index][index1]}
                                      ></StatusIndicator>
                                    )}
                                </>
                              ),
                            }}
                          />
                        </Box>
                      );
                    })}
                {showAnswer && userAnswer && userAnswer[index] && (
                  <Typography
                    sx={{
                      color: "primary.main",
                      fontWeight: "500",
                      "@media (min-width: 1636px)": { fontSize: "1.2rem" },
                    }}
                  >
                    {userAnswer[index].join(" | ")}
                  </Typography>
                )}
              </Grid>
            </Grid>
          );
        })}
    </Box>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: "63vh",
    overflow: "auto",
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default THESAURUS;
